import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-user-profile-badges',
    templateUrl: './user-profile-badges.component.html',
    styleUrls: ['./user-profile-badges.component.scss']
})
export class UserProfileBadgesComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
